import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const updateUser = async <T extends Action<ACTION_TYPE.UPDATE_USER>>({ user }: T['payload']): Promise<T['response']> => {
  try {
    if (!user) throw new Error('User not found on update')

    const body = await actionsRequest<T>({
      payload: {
        user
      },
      type: ACTION_TYPE.UPDATE_USER
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const updatedUser = body.data
    if (!updatedUser) throw new Error(ERROR_CODE.USER_NOT_FOUND)

    return updatedUser
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.UPDATE_USER, {
      user
    })
    throw err
  }
}

export const createUser = async <T extends Action<ACTION_TYPE.CREATE_USER>>({ user }: T['payload']): Promise<T['response']> => {
  try {
    if (!user) throw new Error('User not found on creation')

    const body = await actionsRequest<T>({
      payload: {
        user
      },
      type: ACTION_TYPE.CREATE_USER
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const createdUser = body.data
    if (!createdUser) throw new Error(ERROR_CODE.USER_NOT_FOUND)

    return createdUser
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.CREATE_USER, {
      user
    })
    throw err
  }
}

export const getUser = async <T extends Action<ACTION_TYPE.GET_USER>>({ userId }: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        userId
      },
      type: ACTION_TYPE.GET_USER
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const user = body.data

    return user
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_USER, {
      userId
    })
    throw err
  }
}

export const getRouteConditions = async <T extends Action<ACTION_TYPE.GET_ROUTE_CONDITIONS>>({
  uniqueId,
  type
}: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        uniqueId,
        type
      },
      type: ACTION_TYPE.GET_ROUTE_CONDITIONS
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_ROUTE_CONDITIONS, {
      uniqueId,
      type
    })
    throw err
  }
}

export const setUserInfo = async <T extends Action<ACTION_TYPE.SET_USER_INFO>>(data: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: data,
      type: ACTION_TYPE.SET_USER_INFO
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.SET_USER_INFO, data)
    throw err
  }
}
